export default __webpack_public_path__ + "static/media/goals.617e9df2.png";